import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import FileDetailsTable from './FileDetailsTable';
import FileDetailsLabel from './FileDetailsLabel';
import dataAids from '../../../../constants/dataAids';
import PropTypes from 'prop-types';

const styles = {
  wrapper: {
    'marginBottom': 'large',
    'textAlign': 'center',
    '@sm': {
      textAlign: 'left'
    }
  },
  digital: {
    'marginBottom': 'xxsmall',
    'fontColor': 'highContrast',
    'textAlign': 'center',
    '@sm': {
      textAlign: 'left'
    }
  }
};

const Files = ({ translate, files, wrapperStyle }) => {
  if (!files || files.length === 0) return null;
  const { Block } = UX2.Element;

  return (
    <Block
      style={{ ...styles.wrapper, ...wrapperStyle }}
      data-aid={ dataAids.PRODUCT_FILES_RENDERED }
    >
      <FileDetailsLabel translate={ translate } fileCount={ files.length } />
      <FileDetailsTable translate={ translate } files={ files } />
    </Block>
  );
};

Files.propTypes = {
  files: PropTypes.array,
  translate: PropTypes.func,
  wrapperStyle: PropTypes.object
};

export default Files;
